import { useEffect, useState } from "react";

import { useSpring } from "@react-spring/web";

import { guideActions } from "../../../guides/storage";

import type { OnboardingGuideState } from "../../../guides/storage";

interface UseCaughtUpAutoDismissOptions {
  isTopCard: boolean;
  setGuideState: React.Dispatch<React.SetStateAction<OnboardingGuideState>>;
}

export const useCaughtUpAutoDismiss = ({
  isTopCard,
  setGuideState,
}: UseCaughtUpAutoDismissOptions) => {
  const [caughtUpFading, setCaughtUpFading] = useState(false);

  const caughtUpSpring = useSpring({
    opacity: caughtUpFading ? 0 : 1,
    config: { tension: 180, friction: 26 },
    onRest: () => {
      if (caughtUpFading) {
        setCaughtUpFading(false);
        setGuideState(guideActions.dismissCaughtUp);
      }
    },
  });

  useEffect(() => {
    if (!isTopCard || caughtUpFading) return undefined;
    const timer = setTimeout(() => {
      setCaughtUpFading(true);
    }, 2000);
    return (): void => clearTimeout(timer);
  }, [isTopCard, caughtUpFading]);

  return { caughtUpSpring };
};
